import React, { FC } from 'react';
import styles from './index.module.scss';
import DocumentsLibrary from 'src/common/DocumentsLibrary';
import { Modal } from 'src/common';
import { useTranslation } from 'react-i18next';
import { DocumentsColumnsName } from 'src/common/DocumentsLibrary/types';
import { IFileNode } from 'src/models/documentsLibrary/types';

interface IProps {
  onClose: () => void;
  onAttach: (fileId: string) => void;
  files: IFileNode[];
  isLoading?: boolean;
}

const hideColumn = [DocumentsColumnsName.actions] as const;

const TextResponseModal: FC<IProps> = (props: IProps) => {
  const { onClose, onAttach, files, isLoading } = props;
  const { t } = useTranslation();

  return (
    <Modal
      title={<span>{t('BiddingTool.attachFile')}</span>}
      visible
      onCancel={onClose}
      className={styles.modal}
      maskClosable
      width={700}
      footer={null}
    >
      <DocumentsLibrary isAttachLoading={isLoading} hideFields={hideColumn} onAttach={onAttach} files={files} />
    </Modal>
  );
};

export default TextResponseModal;
